import { m } from '@/lib/paraglide/messages'

// Nơi đang trỏ link tới bài / trang (params.where của SHOP_CONTENT_LINKED, vd
// "home:hero_slide,settings:footer") → chữ đọc được.

const HOME: Record<string, () => string> = {
    hero_slide: m.cmsPost_place_home_hero,
    home_tab: m.cmsPost_place_home_tab,
    promo: m.cmsPost_place_home_promo,
    gift_banner: m.cmsPost_place_home_gift,
    story: m.cmsPost_place_home_story,
    ocop: m.cmsPost_place_home_ocop,
    store_system: m.cmsPost_place_home_store,
}

export function contentLinkPlaces(where: string): string {
    return where
        .split(',')
        .filter(Boolean)
        .map((w) => {
            const [scope, kind = ''] = w.split(':')
            if (scope === 'home') return (HOME[kind] ?? m.cmsPost_place_home)()
            if (scope === 'settings') return m.cmsPost_place_settings({ kind })
            if (scope === 'group') return m.cmsPage_place_group({ slug: kind })
            return w
        })
        .join(', ')
}
